import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import WelcomeStep from "./WelcomeStep";
import CsvUploadStep from "./CsvUploadStep";
import ApiKeyStep from "./ApiKeyStep";
import CompleteStep from "./CompleteStep";

const Onboarding = ({ onComplete }) => {
  const navigate = useNavigate();
  console.log("onComplete in Onboarding:", onComplete);

  const [step, setStep] = useState(0);

  const nextStep = () => {
    console.log("Navigating to step:", step + 1);
    setStep((prevStep) => prevStep + 1);
  };

  const previousStep = () => {
    console.log("Navigating back to step:", step - 1);
    setStep((prevStep) => prevStep - 1);
  };

  const handleComplete = () => {
    console.log("Onboarding complete. Redirecting to dashboard...");
    const token = localStorage.getItem("token");
    if (!token) {
      console.error("No token found in localStorage. Redirecting to login.");
      navigate("/login");
      return;
    }

    console.log("Token found. Redirecting to /dashboard...");
    navigate("/dashboard");

    if (onComplete) {
      onComplete(); // Call the onComplete callback if provided
    }
  };

  const steps = [
    <WelcomeStep onNext={nextStep} />,
    <CsvUploadStep onNext={nextStep} onBack={previousStep} />,
    <CompleteStep onFinish={handleComplete} />, // Use handleComplete here
  ];

  console.log("Current step:", step);

  return <div>{steps[step]}</div>;
};

export default Onboarding;
